import './featured-topics/common';
import initFt1 from './featured-topics/ft1';
import initFt2 from './featured-topics/ft2';

export default function initFeaturedBlocks() {
    initFt1();
    initFt2();
}
